// extracted by mini-css-extract-plugin
module.exports = {"skeletonLoader":"styles_skeletonLoader__LNyzv","innerDecoration":"styles_innerDecoration__0_qzd","translate-repeat":"styles_translate-repeat___J0NE","light":"styles_light__h047F"};